import { render } from "./UiIconPlusSmSolid.vue?vue&type=template&id=6ff1d8e4"
const script = {}

import exportComponent from "C:\\Users\\merk\\Documents\\_kwork\\virginia79\\lk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__